(function () {
  'use strict';

  var sectionRenderControllers = new WeakMap();
  var popstateBound = false;

  function getSectionEls(section) {
    var sectionId = section.dataset.homlandSectionId || '';
    return {
      sectionId: sectionId,
      collectionUrl: section.dataset.homlandCollectionUrl || '',
      sortBy: section.dataset.homlandSortBy || '',
      clientMode: section.dataset.homlandClientMode || '',
      sidebar: document.getElementById('homland-sidebar-form-' + sectionId),
      overlay: document.getElementById('homland-sidebar-overlay-' + sectionId),
      openBtn: document.getElementById('homland-open-sidebar-' + sectionId),
      closeBtn: document.getElementById('homland-close-sidebar-' + sectionId),
      grid: document.getElementById('homland-prod-grid-' + sectionId),
      countEl: section.querySelector('[data-homland-result-count]'),
      filterCountEl: section.querySelector('[data-homland-filter-count]'),
      emptyState: section.querySelector('[data-homland-client-empty]'),
      clearAll: null,
      sortSelect: section.querySelector('[data-homland-sort-select]')
    };
  }

  function refreshClearAll(els) {
    els.clearAll = els.sidebar ? els.sidebar.querySelector('.homland-clear-all') : null;
    return els.clearAll;
  }

  function openSidebar(els) {
    if (!els.sidebar) return;
    els.sidebar.classList.add('active');
    if (els.overlay) {
      els.overlay.classList.add('active');
      els.overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar(els) {
    if (!els.sidebar) return;
    els.sidebar.classList.remove('active');
    if (els.overlay) {
      els.overlay.classList.remove('active');
      els.overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
  }

  function isSidebarOpen(section) {
    var sidebar = section.querySelector('.homland-sidebar');
    return !!(sidebar && sidebar.classList.contains('active'));
  }

  function setLoading(section, loading) {
    section.classList.toggle('is-loading', loading);
    section.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function buildPublicUrl(collectionUrl, params) {
    var query = params.toString();
    return collectionUrl + (query ? '?' + query : '');
  }

  function paramsFromForm(sidebar, options) {
    options = options || {};
    var omitClientFilters = !!options.omitClientFilters;
    var params = new URLSearchParams();
    if (!sidebar || !sidebar.elements) return params;

    // Walk named controls so we can skip .homland-client-filter for native section renders.
    Array.prototype.forEach.call(sidebar.elements, function (el) {
      if (!el || !el.name || el.disabled) return;
      if (omitClientFilters && el.classList && el.classList.contains('homland-client-filter')) return;

      var type = (el.type || '').toLowerCase();
      if (type === 'submit' || type === 'button' || type === 'file' || type === 'reset') return;
      if ((type === 'checkbox' || type === 'radio') && !el.checked) return;

      var value = el.value;
      if (value === null || value === undefined) return;
      var stringValue = String(value);
      if (stringValue === '') return;
      params.append(el.name, stringValue);
    });
    return params;
  }

  function cleanHistoryUrl(url) {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('section_id');
    return parsed.pathname + parsed.search + (window.location.hash || '');
  }

  function clientFilterParamNames(section) {
    if (!section || !section.dataset) return [];
    var d = section.dataset;
    var mode = d.homlandClientMode || '';
    var clientParamsByMode = {
      'bathroom-safety': [d.homlandProductTypeParam, d.homlandSceneParam, d.homlandNeedParam, d.homlandFitParam],
      'best-seller': [d.homlandProductTypeParam, d.homlandCategoryParam, d.homlandPriceParam, d.homlandAvailabilityParam, d.homlandColorParam, d.homlandNeedParam],
      'raised-toilet-seat': [d.homlandUseParam, d.homlandRaisedSeatHeightParam, d.homlandBaseWidthParam, d.homlandSpecialParam, d.homlandColorParam, d.homlandAvailabilityParam],
      'walker': [d.homlandNeedParam, d.homlandStyleParam, d.homlandCapacityParam, d.homlandSeatComfortParam, d.homlandFoldStoreParam],
      'toilet-safety-rail': [d.homlandRailNeedParam, d.homlandRailFitParam],
      'bedside-commode': [d.homlandCommodeNeedParam, d.homlandCommodeFitParam, d.homlandCommodeFeatureParam],
      'shower': [d.homlandBathroomParam, d.homlandFormParam, d.homlandSupportParam, d.homlandSeatParam]
    };
    return (clientParamsByMode[mode] || []).filter(Boolean);
  }

  function sectionRequestUrl(sectionId, url, section) {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('section_id');
    // Never send client-only metafield filters to Section Rendering (popstate + deep links).
    clientFilterParamNames(section).forEach(function (param) {
      parsed.searchParams.delete(param);
    });
    parsed.searchParams.set('section_id', sectionId);
    return parsed.toString();
  }

  function extractSectionNode(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return (
      doc.querySelector('[data-homland-collection-filters]') ||
      doc.querySelector('section.homland-sec.collection') ||
      doc.body.firstElementChild
    );
  }

  function scrollToProductList(section) {
    var anchor = section.querySelector('#product-list') || section.querySelector('.homland-main-content');
    if (anchor && typeof anchor.scrollIntoView === 'function') {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function renderSection(section, url, options) {
    options = options || {};
    var sectionId = section.dataset.homlandSectionId;
    // historyUrl may retain client-filter params for shareable links while `url` is native-only.
    var historySource = options.historyUrl || url;
    if (!sectionId) {
      window.location.href = historySource;
      return Promise.resolve();
    }

    var prev = sectionRenderControllers.get(section);
    if (prev) prev.abort();
    var controller = new AbortController();
    sectionRenderControllers.set(section, controller);

    var keepSidebarOpen = options.keepSidebarOpen != null ? options.keepSidebarOpen : isSidebarOpen(section);
    setLoading(section, true);

    return fetch(sectionRequestUrl(sectionId, url, section), {
      credentials: 'same-origin',
      signal: controller.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Section render failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (controller.signal.aborted) return;

        var sourceNode = extractSectionNode(html);
        if (!sourceNode) throw new Error('Section markup missing');

        var nextSection = document.importNode(sourceNode, true);
        if (!nextSection || !nextSection.nodeType) throw new Error('Invalid section node');

        // Ensure marker attributes survive partial markup differences
        if (!nextSection.hasAttribute('data-homland-collection-filters')) {
          nextSection.setAttribute('data-homland-collection-filters', '');
        }
        if (!nextSection.dataset.homlandSectionId && sectionId) {
          nextSection.dataset.homlandSectionId = sectionId;
        }

        section.replaceWith(nextSection);
        sectionRenderControllers.delete(section);

        if (options.pushState !== false) {
          var publicUrl = cleanHistoryUrl(historySource);
          if (publicUrl !== window.location.pathname + window.location.search + window.location.hash) {
            window.history.pushState({ homlandCollection: true }, '', publicUrl);
          }
        }

        initCollectionFilters(nextSection);

        // replaceWith drops the old drawer markup without closeSidebar(); always resync body scroll.
        if (keepSidebarOpen) {
          openSidebar(getSectionEls(nextSection));
        } else {
          document.body.style.overflow = '';
        }

        if (options.scroll !== false) {
          scrollToProductList(nextSection);
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        setLoading(section, false);
        // Unlock scroll before full navigation in case the drawer left body locked.
        document.body.style.overflow = '';
        window.location.href = cleanHistoryUrl(historySource);
      });
  }

  function renderFromForm(section, options) {
    var els = getSectionEls(section);
    if (!els.sidebar || !els.collectionUrl) {
      window.location.reload();
      return Promise.resolve();
    }

    // Native section render must not send client-only metafield checkboxes to Shopify,
    // or Search & Discovery can shrink the product set before applyClientFilters runs.
    var serverParams = paramsFromForm(els.sidebar, { omitClientFilters: true });
    serverParams.delete('page');
    var serverUrl = buildPublicUrl(els.collectionUrl, serverParams);

    // Keep client filters in the public URL so share/back and re-init still re-apply them.
    var publicParams = paramsFromForm(els.sidebar, { omitClientFilters: false });
    publicParams.delete('page');
    var historyUrl = buildPublicUrl(els.collectionUrl, publicParams);

    var nextOptions = options ? Object.assign({}, options) : {};
    nextOptions.historyUrl = historyUrl;
    return renderSection(section, serverUrl, nextOptions);
  }

  function bindShellUi(section, els) {
    if (els.openBtn) {
      els.openBtn.addEventListener('click', function () {
        openSidebar(getSectionEls(section));
      });
    }
    if (els.closeBtn) {
      els.closeBtn.addEventListener('click', function () {
        closeSidebar(getSectionEls(section));
      });
    }
    if (els.overlay) {
      els.overlay.addEventListener('click', function () {
        closeSidebar(getSectionEls(section));
      });
    }

    if (!els.sidebar) return;

    els.sidebar.querySelectorAll('[data-homland-filter-toggle]').forEach(function (title) {
      title.addEventListener('click', function () {
        var collapsed = title.classList.toggle('collapsed');
        if (title.nextElementSibling) title.nextElementSibling.classList.toggle('collapsed', collapsed);
        title.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
      title.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          title.click();
        }
      });
    });

    els.sidebar.querySelectorAll('[data-homland-more-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var root = toggle.closest('[data-homland-more-filters]');
        var panel = root ? root.querySelector('.homland-more-filters__panel') : null;
        var icon = toggle.querySelector('.homland-more-filters__icon');
        if (!panel) return;
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          panel.setAttribute('hidden', '');
          if (icon) icon.textContent = '+';
        } else {
          panel.removeAttribute('hidden');
          if (icon) icon.textContent = '−';
        }
      });
    });

    // Progressive enhancement: intercept native form submit
    els.sidebar.addEventListener('submit', function (event) {
      event.preventDefault();
      renderFromForm(section, { keepSidebarOpen: isSidebarOpen(section), scroll: true });
    });

    // Native Shopify filters (Color, Availability, etc.)
    els.sidebar.querySelectorAll('input.homland-custom-cb:not(.homland-client-filter)').forEach(function (input) {
      input.addEventListener('change', function () {
        renderFromForm(section, { keepSidebarOpen: true, scroll: true });
      });
    });
  }

  function bindSortAndPagination(section, els) {
    if (els.sortSelect) {
      els.sortSelect.addEventListener('change', function () {
        var live = getSectionEls(section);
        var value = live.sortSelect ? live.sortSelect.value : els.sortSelect.value;
        var hidden = document.getElementById('hidden-sort-by-' + live.sectionId);
        if (hidden) hidden.value = value;
        if (live.sidebar) {
          var sortInput = live.sidebar.querySelector('input[name="sort_by"]');
          if (sortInput) sortInput.value = value;
        }
        renderFromForm(section, { keepSidebarOpen: isSidebarOpen(section), scroll: true });
      });
    }

    section.querySelectorAll('.homland-pagination a[href]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        renderSection(section, link.href, {
          keepSidebarOpen: false,
          scroll: true
        });
      });
    });

    var clearAll = refreshClearAll(els);
    if (clearAll) {
      clearAll.addEventListener('click', function (event) {
        if (clearAll.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        var href = clearAll.getAttribute('href') || section.dataset.homlandCollectionUrl || window.location.pathname;
        renderSection(section, href, {
          keepSidebarOpen: isSidebarOpen(section),
          scroll: true
        });
      });
    }

    // Server empty-state clear
    section.querySelectorAll('a.homland-btn-o[href*="sort_by"], a[data-homland-client-empty-clear]').forEach(function (link) {
      if (link.classList.contains('homland-clear-all')) return;
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) === '#') return;
        // Only intercept clear-style links inside collection main content
        if (!link.closest('.homland-empty-state') && !link.hasAttribute('data-homland-client-empty-clear')) return;
        event.preventDefault();
        renderSection(section, href, { keepSidebarOpen: false, scroll: true });
      });
    });
  }

  function bindClientFilters(section, els) {
    var clientMode = els.clientMode;
    var grid = els.grid;
    if (!clientMode || !grid || grid.getAttribute('data-homland-client-filters') !== 'true') return;
    if (clientMode === 'solution') return;

    var filterKeys;
    var singleSelectKeys = {};
    var choiceExclusiveKeys;

    if (clientMode === 'bathroom-safety') {
      filterKeys = {
        productType: { param: section.dataset.homlandProductTypeParam, attr: 'hlProductType' },
        scene: { param: section.dataset.homlandSceneParam, attr: 'hlScene' },
        need: { param: section.dataset.homlandNeedParam, attr: 'hlNeed' },
        fit: { param: section.dataset.homlandFitParam, attr: 'hlFit' }
      };
      singleSelectKeys = { scene: true, fit: true };
      choiceExclusiveKeys = ['scene'];
    } else if (clientMode === 'best-seller') {
      filterKeys = {
        productType: { param: section.dataset.homlandProductTypeParam, attr: 'hlProductType' },
        need: { param: section.dataset.homlandNeedParam, attr: 'hlNeed' },
        category: { param: section.dataset.homlandCategoryParam, attr: 'hlCategory' },
        price: { param: section.dataset.homlandPriceParam, attr: 'hlPrice' },
        availability: { param: section.dataset.homlandAvailabilityParam, attr: 'hlAvailability' },
        color: { param: section.dataset.homlandColorParam, attr: 'hlColor' }
      };
      choiceExclusiveKeys = [];
    } else if (clientMode === 'raised-toilet-seat') {
      filterKeys = {
        use: { param: section.dataset.homlandUseParam, attr: 'hlUse' },
        seat: { param: section.dataset.homlandRaisedSeatHeightParam, attr: 'hlSeatHeight' },
        base: { param: section.dataset.homlandBaseWidthParam, attr: 'hlBaseWidth' },
        special: { param: section.dataset.homlandSpecialParam, attr: 'hlSpecial' },
        color: { param: section.dataset.homlandColorParam, attr: 'hlColor' },
        availability: { param: section.dataset.homlandAvailabilityParam, attr: 'hlAvailability' }
      };
      choiceExclusiveKeys = Object.keys(filterKeys);
    } else if (clientMode === 'walker') {
      filterKeys = {
        need: { param: section.dataset.homlandNeedParam, attr: 'hlNeed' },
        style: { param: section.dataset.homlandStyleParam, attr: 'hlStyle' },
        capacity: { param: section.dataset.homlandCapacityParam, attr: 'hlCapacity' },
        seat: { param: section.dataset.homlandSeatComfortParam, attr: 'hlSeatComfort' },
        fold: { param: section.dataset.homlandFoldStoreParam, attr: 'hlFoldStore' }
      };
      choiceExclusiveKeys = ['need'];
    } else if (clientMode === 'toilet-safety-rail') {
      filterKeys = {
        need: { param: section.dataset.homlandRailNeedParam, attr: 'hlNeed' },
        fit: { param: section.dataset.homlandRailFitParam, attr: 'hlFit' }
      };
      singleSelectKeys = { fit: true };
      choiceExclusiveKeys = ['fit'];
    } else if (clientMode === 'bedside-commode') {
      filterKeys = {
        need: { param: section.dataset.homlandCommodeNeedParam, attr: 'hlNeed' },
        fit: { param: section.dataset.homlandCommodeFitParam, attr: 'hlFit' },
        feature: { param: section.dataset.homlandCommodeFeatureParam, attr: 'hlFeature' }
      };
      singleSelectKeys = { fit: true, feature: true };
      choiceExclusiveKeys = ['need'];
    } else {
      filterKeys = {
        bathroom: { param: section.dataset.homlandBathroomParam, attr: 'hlBathroom' },
        form: { param: section.dataset.homlandFormParam, attr: 'hlForm' },
        support: { param: section.dataset.homlandSupportParam, attr: 'hlSupport' },
        seat: { param: section.dataset.homlandSeatParam, attr: 'hlSeat' }
      };
      singleSelectKeys = { bathroom: true };
      choiceExclusiveKeys = ['bathroom'];
    }

    function liveSidebar() {
      return getSectionEls(section).sidebar;
    }

    function liveGrid() {
      return getSectionEls(section).grid;
    }

    function selectedLabels(key) {
      var sidebar = liveSidebar();
      var labels = Array.from(
        sidebar ? sidebar.querySelectorAll('input.homland-client-filter[data-hl-filter="' + key + '"]:checked') : []
      ).map(function (element) {
        return element.getAttribute('data-hl-label') || element.value;
      });
      if (singleSelectKeys[key] && labels.length > 1) labels = [labels[labels.length - 1]];
      return labels;
    }

    function setCheckboxState(key, labels) {
      var list = labels || [];
      if (singleSelectKeys[key] && list.length > 1) list = [list[list.length - 1]];
      var selected = new Set(list);
      var sidebar = liveSidebar();
      if (!sidebar) return;
      sidebar.querySelectorAll('input.homland-client-filter[data-hl-filter="' + key + '"]').forEach(function (element) {
        var label = element.getAttribute('data-hl-label') || element.value;
        element.checked = selected.has(label);
      });
    }

    function clearChoiceExclusiveKeys(exceptKey) {
      choiceExclusiveKeys.forEach(function (key) {
        if (key === exceptKey) return;
        setCheckboxState(key, []);
      });
    }

    function syncChoiceBar() {
      document.querySelectorAll('.hl-col-cat-choice__item[data-hl-filter]').forEach(function (link) {
        var key = link.getAttribute('data-hl-filter') || '';
        var label = link.getAttribute('data-hl-label') || '';
        if (!key || !filterKeys[key]) {
          link.classList.remove('is-active');
          link.removeAttribute('aria-current');
          link.removeAttribute('title');
          return;
        }
        var active = selectedLabels(key).indexOf(label) !== -1;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'true');
          link.setAttribute('title', '再次点击取消筛选');
        } else {
          link.removeAttribute('aria-current');
          link.removeAttribute('title');
        }
      });
    }

    function cardMatches(card, key, selected) {
      if (!selected.length) return true;
      var raw = card.dataset[filterKeys[key].attr] || '';
      var values = raw.split('|').map(function (value) { return value.trim().toLowerCase(); }).filter(Boolean);
      return selected.some(function (value) {
        var v = value.trim().toLowerCase();
        if (v === 'gray' && values.indexOf('grey') !== -1) return true;
        if (v === 'grey' && values.indexOf('gray') !== -1) return true;
        if (v === 'gold' && values.some(function (x) { return x.indexOf('gold') !== -1; })) return true;
        return values.indexOf(v) !== -1;
      });
    }

    function collectSelected() {
      var selected = {};
      Object.keys(filterKeys).forEach(function (key) {
        selected[key] = selectedLabels(key);
      });
      return selected;
    }

    function nativeUrlFilterCount() {
      var params = new URLSearchParams(window.location.search);
      var clientParams = new Set(Object.keys(filterKeys).map(function (key) {
        return filterKeys[key].param;
      }).filter(Boolean));
      var nativeParams = [
        section.dataset.homlandColorParam,
        section.dataset.homlandAvailabilityParam,
        'filter.v.t.shopify.color-pattern'
      ].filter(function (param) { return param && !clientParams.has(param); });
      return Array.from(new Set(nativeParams)).reduce(function (count, param) {
        return count + params.getAll(param).length;
      }, 0);
    }

    function updateFilterCount(selected) {
      var live = getSectionEls(section);
      if (!live.filterCountEl) return;
      var clientCount = Object.keys(selected).reduce(function (count, key) {
        return count + selected[key].length;
      }, 0);
      var sidebar = live.sidebar;
      var nativeCheckedCount = sidebar
        ? sidebar.querySelectorAll('input.homland-custom-cb:not(.homland-client-filter):checked').length
        : 0;
      var nativeCount = Math.max(nativeCheckedCount, nativeUrlFilterCount());
      var total = clientCount + nativeCount;
      live.filterCountEl.textContent = String(total);
      live.filterCountEl.hidden = total === 0;
    }

    function expandActiveGroups() {
      var sidebar = liveSidebar();
      if (!sidebar) return;
      sidebar.querySelectorAll('input.homland-client-filter:checked').forEach(function (input) {
        var group = input.closest('.homland-filter-group');
        var title = group ? group.querySelector('[data-homland-filter-toggle]') : null;
        var list = title ? title.nextElementSibling : null;
        if (title) title.classList.remove('collapsed');
        if (list) list.classList.remove('collapsed');
      });
    }

    function updateClearState(selected) {
      var live = getSectionEls(section);
      var clearAll = refreshClearAll(live);
      if (!clearAll) return;
      var hasClientFilter = Object.keys(selected).some(function (key) { return selected[key].length > 0; });
      var hasNativeFilter =
        (live.sidebar && live.sidebar.querySelector('input.homland-custom-cb:not(.homland-client-filter):checked')) ||
        nativeUrlFilterCount() > 0;
      var disabled = !hasClientFilter && !hasNativeFilter;
      clearAll.classList.toggle('is-disabled', disabled);
      if (disabled) {
        clearAll.setAttribute('aria-disabled', 'true');
        clearAll.setAttribute('tabindex', '-1');
      } else {
        clearAll.removeAttribute('aria-disabled');
        clearAll.removeAttribute('tabindex');
      }
    }

    function updateClientEmptyState(visible) {
      var live = getSectionEls(section);
      if (live.emptyState) live.emptyState.hidden = visible > 0;
    }

    function buildClientUrl(selected) {
      var live = getSectionEls(section);
      var params = new URLSearchParams(window.location.search);
      Object.keys(filterKeys).forEach(function (key) {
        if (filterKeys[key].param) params.delete(filterKeys[key].param);
      });
      Object.keys(selected).forEach(function (key) {
        if (!filterKeys[key].param) return;
        selected[key].forEach(function (label) {
          params.append(filterKeys[key].param, label);
        });
      });
      // Preserve native filters already in the URL / form
      var sortBy = live.sortBy || params.get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);
      var query = params.toString();
      return (live.collectionUrl || section.dataset.homlandCollectionUrl || '') + (query ? '?' + query : '') + (window.location.hash || '');
    }

    function applyClientFilters(pushUrl) {
      var selected = collectSelected();
      var visible = 0;
      var currentGrid = liveGrid();
      if (!currentGrid) return;

      currentGrid.querySelectorAll('.homland-p-card').forEach(function (card) {
        var visibleForFilters = Object.keys(selected).every(function (key) {
          return cardMatches(card, key, selected[key]);
        });
        card.hidden = !visibleForFilters;
        card.style.display = visibleForFilters ? '' : 'none';
        if (visibleForFilters) visible += 1;
      });

      var live = getSectionEls(section);
      if (live.countEl) live.countEl.textContent = String(visible);
      updateClientEmptyState(visible);
      updateFilterCount(selected);
      syncChoiceBar();
      expandActiveGroups();
      updateClearState(selected);

      if (pushUrl) {
        var nextUrl = buildClientUrl(selected);
        if (nextUrl !== window.location.href) window.history.pushState({ homlandCollection: true }, '', nextUrl);
      }
    }

    function readUrlIntoCheckboxes() {
      var params = new URLSearchParams(window.location.search);
      Object.keys(filterKeys).forEach(function (key) {
        if (!filterKeys[key].param) return;
        var labels = params.getAll(filterKeys[key].param);
        setCheckboxState(key, singleSelectKeys[key] ? labels.slice(-1) : labels);
      });
    }

    var sidebar = liveSidebar();
    if (sidebar) {
      sidebar.querySelectorAll('input.homland-client-filter').forEach(function (input) {
        input.addEventListener('change', function () {
          var key = input.getAttribute('data-hl-filter') || '';
          if (input.checked && singleSelectKeys[key]) {
            setCheckboxState(key, [input.getAttribute('data-hl-label') || input.value]);
          }
          applyClientFilters(true);
        });
      });
    }

    // Choice bar lives outside the section — bind once per page via data flag
    if (!document.documentElement.hasAttribute('data-homland-choice-bar-bound')) {
      document.documentElement.setAttribute('data-homland-choice-bar-bound', 'true');
      document.addEventListener('click', function (event) {
        var link = event.target.closest('.hl-col-cat-choice__item[data-hl-filter]');
        if (!link) return;

        var activeSection = document.querySelector('[data-homland-collection-filters]');
        if (!activeSection || activeSection.dataset.homlandFilterInit !== 'true') return;
        if (!activeSection.dataset.homlandClientMode) return;

        // Re-enter client binder API through a synthetic path: dispatch only if filters exist
        var key = link.getAttribute('data-hl-filter');
        var label = link.getAttribute('data-hl-label');
        if (!key || !label) return;

        // Only handle when current section has client filters
        var currentGrid = document.getElementById('homland-prod-grid-' + activeSection.dataset.homlandSectionId);
        if (!currentGrid || currentGrid.getAttribute('data-homland-client-filters') !== 'true') return;

        // Use a custom event so the live section instance can handle it
        event.preventDefault();
        activeSection.dispatchEvent(
          new CustomEvent('homland:choice-filter', {
            bubbles: false,
            detail: { key: key, label: label, link: link }
          })
        );
      });
    }

    section.addEventListener('homland:choice-filter', function (event) {
      var key = event.detail && event.detail.key;
      var label = event.detail && event.detail.label;
      if (!key || !label || !filterKeys[key]) return;

      var current = selectedLabels(key);
      var isActive = current.indexOf(label) !== -1;
      if (isActive) {
        setCheckboxState(key, current.filter(function (value) { return value !== label; }));
      } else {
        clearChoiceExclusiveKeys(key);
        if (singleSelectKeys[key] || choiceExclusiveKeys.indexOf(key) !== -1) {
          setCheckboxState(key, [label]);
        } else {
          setCheckboxState(key, current.concat([label]));
        }
      }
      applyClientFilters(true);
      var live = getSectionEls(section);
      var main = document.getElementById('shopify-section-main') || live.grid;
      if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
      closeSidebar(live);
    });

    // Expose for popstate when only client params changed (no full section reload needed)
    section._homlandApplyClientFilters = function (pushUrl) {
      readUrlIntoCheckboxes();
      applyClientFilters(!!pushUrl);
    };

    readUrlIntoCheckboxes();
    applyClientFilters(false);
  }

  function initCollectionFilters(section) {
    if (!section || section.dataset.homlandFilterInit === 'true') return;
    section.dataset.homlandFilterInit = 'true';

    var els = getSectionEls(section);
    bindShellUi(section, els);
    bindSortAndPagination(section, els);
    bindClientFilters(section, els);
  }

  function initAll() {
    document.querySelectorAll('[data-homland-collection-filters]').forEach(initCollectionFilters);
  }

  function bindPopstateOnce() {
    if (popstateBound) return;
    popstateBound = true;
    window.addEventListener('popstate', function () {
      var section = document.querySelector('[data-homland-collection-filters]');
      if (!section) return;

      // Always re-fetch section HTML so sort / page / native filters stay correct.
      // Client-only collections re-apply card filters after init.
      renderSection(section, window.location.pathname + window.location.search, {
        pushState: false,
        keepSidebarOpen: false,
        scroll: false
      });
    });
  }

  initAll();
  bindPopstateOnce();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      bindPopstateOnce();
    });
  }
})();
